import  { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { getBrandById } from "../../redux/actions/brandAction";
// import { getProductsByBrand } from "../../redux/actions/productsAction";
import {
  emptyVendorProducts,
  getAllVendorProductsById,
  getVendorByusername,
} from "../../redux/actions/vendorActions";
// import { useSearchParams } from "react-router-dom";

const ViewProductsByVendorHook = (vendorname) => {

//  const[searchParams]=useSearchParams();

  const [loading, setLoading] = useState(false);
  // const firstRender = useRef(true);

  const dispatch = useDispatch();
  const getById = async () => {
    console.log('getById');
     setLoading(true);
    await dispatch(getVendorByusername(vendorname));
     setLoading(false);
  };
  let limit=20;

  async function getVendorProducts(page){
    console.log('getVendorProducts',page);
   if(vendorByusername?._id){
      setLoading(true);
    await dispatch(getAllVendorProductsById(vendorByusername._id,`limit=${limit}&page=${page}`));
     setLoading(false);
   } 
  }

  const allproduct = useSelector(
    (state) => state.vendorReducer.getProductsByVendorId
  );

  const vendorByusername = useSelector(
    (state) => state.vendorReducer.vendorByUsername
  );

  useEffect(() => {
   // console.log('use effect');
    getById();
  }, [vendorname]);

  // useEffect(()=>{
  //    return () => {
  //     dispatch(emptyVendorProducts());
  //   };
  // },[]);

 

  useEffect(() => {
    getVendorProducts(1);
  }, [vendorByusername]);

  

  let items = [];
  let pagination=0;

  try {
    if (allproduct)
      if (allproduct) {
        items = allproduct.data;
        pagination=allproduct.numberOfPages;
      }

      else items = [];
  } catch (error) {}

  const getPage = async (page) => {
      console.log('get page',page);
      getVendorProducts(page);
  }

  return [items, vendorByusername, loading,pagination,getPage];
};

export default ViewProductsByVendorHook;
